/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  useGetReportsQuery,
  ReportsSortInput,
  ReportsFilterInput,
} from "~/generated/graphql";

type Props = {
  page?: string;
  limit?: string;
  sort?: ReportsSortInput;
  filter?: ReportsFilterInput;
  skip?: boolean;
};

export function useGetReports({ page, limit, sort, filter, skip }: Props) {
  const {
    data: reportsData,
    loading,
    error,
    startPolling,
    stopPolling,
  } = useGetReportsQuery({
    variables: {
      page: page ? Number(page) : undefined,
      limit: limit ? Number(limit) : undefined,
      sort,
      filter,
    },
    skip,
  });

  const data = reportsData?.reports?.result || [];
  const count = reportsData?.reports?.pageInfo?.count || 0;

  return { data, loading, error, count, startPolling, stopPolling } as const;
}
